import React from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Temples from './pages/Temples';
import TempleDetails from './pages/TempleDetails';
import Blog from './pages/Blog';
import BlogDetails from './pages/BlogDetails';
import Forum from './pages/Forum';
import Polls from './pages/Polls';

// New Imports
import Login from './pages/Login.jsx';
import Signup from './pages/Signup.jsx';
import WriteBlog from './pages/WriteBlog';
import ProtectedRoute from './components/ProtectedRoute';

// CMS Imports
import CmsLayout from './cms/CmsLayout';
import Dashboard from './cms/Dashboard';
import ManageBlogs from './cms/ManageBlogs';
import ManageAds from './cms/ManageAds';
import ManageUsers from './cms/ManageUsers';
import ManageTemples from './cms/ManageTemples';
import ManageOtherTemples from './cms/ManageOtherTemples';
import ManageSettings from './cms/ManageSettings'; // NEW

function App() {
  return (
    <Router>
      <Routes>
        
        {/* PUBLIC SYSTEM (Wrapped in Main Website Layout) */}
        <Route element={<Layout><Outlet /></Layout>}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/temples" element={<Temples />} />
          <Route path="/temple/:id" element={<TempleDetails />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogDetails />} />
          <Route path="/forum" element={<Forum />} />
          <Route path="/polls" element={<Polls />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          
          {/* Protected Public Routes */}
          <Route path="/write" element={
            <ProtectedRoute>
              <WriteBlog />
            </ProtectedRoute>
          } />
        </Route>

        {/* CMS SYSTEM (Wrapped in isolated Admin Layout) */}
        <Route path="/admin" element={
          <ProtectedRoute>
            <CmsLayout>
              <Outlet />
            </CmsLayout>
          </ProtectedRoute>
        }>
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="temples" element={<ManageTemples />} />
          <Route path="other-temples" element={<ManageOtherTemples />} />
          <Route path="blogs" element={<ManageBlogs />} />
          <Route path="users" element={<ManageUsers />} />
          <Route path="ads" element={<ManageAds />} />
          <Route path="settings" element={<ManageSettings />} />
        </Route>

      </Routes>
    </Router>
  );
}

export default App;